<template>
  <div>
		<div v-if="isLoading" class="loader"></div>
		<div v-if="!isLoading" class="table">
			<div v-if="items && items.length === 0">No Results Found</div>
			<div class="table-header" v-if="showingItems.length > 0">
				<div class="table-header-cell" v-for="(value, key) in showingItems[0]" :key="key">{{key}}</div>
			</div>
			<div class="table-column" v-for="(item, tableIndex) in showingItems" :key="item.id">
				<div class="table-column-cell" v-for="(value, key) in item" :key="key">
					<div class="table-column-cell-title">{{key}}</div>
					<div class="table-column-cell-content">{{value}}</div>
				</div>
				<div class="table-column-options">
					<button @click="$emit('OnAddOn', tableIndex, index)" :class="'table-column-' + addOn.type" v-for="(addOn, index) in addOns" :key="index">{{addOn.text}}</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  props: {
		items:Array,
		hidden:Array,
		isLoading:Boolean,
		addOns:Array,
	},
	computed: {
		showingItems: function () {
			if (this.items != null) {
				if (!this.hidden) { return this.items; }
				var items = [];
				//iterate the items, add to showingItems only the one(s) that are not supposed to be hidden
				for (var i = 0; i < this.items.length; ++i) {
					var item = {};
					for (var k in this.items[i]) {
						if (!this.hidden.includes(k)) {
							item[k] = this.items[i][k];
						}
					}
					items.push(item);
				}
				return items;
			}
			return null;
		}
	}
}
</script>

<style scoped>
.table {
  border-top: 5px solid #001b3d;
  box-shadow: 0 2px 15px 0 rgba(16, 37, 133, 0.1);
  border-radius: 0px 0px 4px 4px;
  padding: 10px;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-flow: column;
  flex-flow: column;
  overflow-x: auto;
}
.table-header {
  display: block;
}
.table-header-cell {
  text-transform: uppercase;
  font-weight: bold;
  border-top: 1px solid #dedede;
  border-bottom: 1px solid #dedede;
}
.table-column:nth-child(even) {
  background-color: rgba(94, 130, 152, 0.02);
}
.table-column-cell {
  display: -webkit-flex;
  display: flex;
  align-items: flex-start;
}
.table-header-cell, .table-column-cell {
  flex: 0 0 200px;
  padding: 10px;
}
.table-column-cell-title {
  display: none;
  text-transform: capitalize;
  font-weight: bold;
  flex: 1;
}
.table-column-cell-content {
  flex: 1;
}
.table-column, .table-header {
  display: -webkit-flex;
  display: flex;
  font-size: .9em;
}
.table-column-options {
  width: 125px;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.table-column-details, .table-column-delete {
  width: 60px;
  padding: 5px;
  text-transform: uppercase;
  color: white;
  border-radius: 5px;
  border: none;
  font-weight: bold;
  font-size: 1em;
  cursor: pointer;
}
.table-column-details {
  background: #39A2D9;
}
.table-column-delete {
  background: #cf000f;
}
@media all and (max-width: 768px) {
  .table-column:nth-child(even) {
    background-color: white;
  }
  .table-header {
    display: none;
  }
  .table-column {
    border-top: 0;
    -webkit-flex-flow: column;
    flex-flow: column;
    box-shadow: 0 2px 15px 0 rgba(16, 37, 133, 0.1);
    margin-bottom: 10px;
  }
  .table-column {
    border-radius: 0.3rem;
    overflow: hidden;
  }
  .table-column-cell, .table-column-options {
    width: auto;
  }
  .table-header-cell, .table-column-cell {
    flex: 1 1 auto;
    padding: 10px;
  }
  .table-column-details, .table-column-delete {
    background-color: inherit;
    border-radius: 0;
    flex:1 1 auto;
    padding: 10px;
    border-top: 1px solid rgba(16, 37, 133, 0.1);
  }
  .table-column-details {
    color: #39A2D9;
    border-right: 1px solid rgba(16, 37, 133, 0.1);
  }
  .table-column-delete {
    color: #cf000f;
  }
  .table-column-cell-title {
    display: block;
  }
}
</style>
